/**
 * Directory – Directory & Listing Bootstrap Theme v. 2.0.1
 * Homepage: https://themes.getbootstrap.com/product/directory-directory-listing-bootstrap-4-theme/
 * Copyright 2021, Bootstrapious - https://bootstrapious.com
 */

"use strict";

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
import SmoothScroll from 'jquery';

import objectFitImages from 'object-fit-images';

$(function () {
    // ------------------------------------------------------- //
    //   Lightbox in galleries
    // ------------------------------------------------------ //

    $(".slider-gallery").each(function () {
        // the containers for all your galleries
        $(this).magnificPopup({
            delegate: "a", // the selector for gallery item
            type: "image",
            gallery: {
                enabled: true,
                tCounter: "", // markup of counter
            },
        });
    });

    $(".gallery").each(function () {
        // the containers for all your galleries
        $(this).magnificPopup({
            delegate: "a", // the selector for gallery item
            type: "image",
            gallery: {
                enabled: true,
            },
        });
    });

    // =====================================================
    //     Reset input
    // =====================================================

    $(".input-expand .form-control").on("focus", function () {
        $(this).parents(".input-expand").addClass("focus");
    });
    $(".input-expand .form-control").on("blur", function () {
        setTimeout(function () {
            $(".input-expand .form-control").parents(".input-expand").removeClass("focus");
        }, 333);
    });

    // =====================================================
    //      Detail slider
    // =====================================================

    var detailSlider = new Swiper(".detail-slider", {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            991: {
                slidesPerView: 4,
            },
            565: {
                slidesPerView: 3,
            },
        },

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    var bookingDetailSlider = new Swiper(".booking-detail-slider", {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // =====================================================
    //      Init swipers automatically
    // =====================================================

    $(".swiper-init").each(function () {
        var slider = $(this),
            configuration = JSON.parse($(this).attr("data-swiper"));

        new Swiper(slider, configuration);
    });

    var homeSlider = new Swiper(".home-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        speed: 1500,
        parallax: true,
        /*
        autoplay: {
            delay: 5000,
        },
        */
        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: "#homeNext",
            prevEl: "#homePrev",
        },
    });

    // =====================================================
    //      Items slider
    // =====================================================

    var itemsSlider = new Swiper(".items-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        roundLengths: true,
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 2,
            },
            565: {
                slidesPerView: 1,
            },
        },

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
    });

    // ------------------------------------------------------- //
    //   Scroll to top button
    // ------------------------------------------------------ //

    $(window).on("scroll", function () {
        if ($(window).scrollTop() >= 1500) {
            $("#scrollTop").fadeIn();
        } else {
            $("#scrollTop").fadeOut();
        }
    });

    $("#scrollTop").on("click", function () {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            1000
        );
    });

    // ------------------------------------------------------- //
    // Adding fade effect to dropdowns
    // ------------------------------------------------------ //

    $.fn.slideDropdownUp = function () {
        $(this).fadeIn().css("transform", "translateY(0)");
        return this;
    };
    $.fn.slideDropdownDown = function (movementAnimation) {
        if (movementAnimation) {
            $(this).fadeOut().css("transform", "translateY(30px)");
        } else {
            $(this).hide().css("transform", "translateY(30px)");
        }
        return this;
    };

    $(".navbar .dropdown").on("show.bs.dropdown", function (e) {
        $(this).find(".dropdown-menu").first().slideDropdownUp();
    });
    $(".navbar .dropdown").on("hide.bs.dropdown", function (e) {
        var movementAnimation = true;

        // if on mobile or navigation to another page
        if ($(window).width() < 992 || (e.clickEvent && e.clickEvent.target.tagName.toLowerCase() === "a")) {
            movementAnimation = false;
        }

        $(this).find(".dropdown-menu").first().slideDropdownDown(movementAnimation);
    });

    // ------------------------------------------------------- //
    //    Collapse button control (used for more/less filters)
    // ------------------------------------------------------ //

    $(".btn-collapse").each(function () {
        var button = $(this),
            collapseId = button.attr("data-bs-target");

        if ($(collapseId).length) {
            var collapseElement = $(collapseId);

            $(collapseElement).on("hide.bs.collapse", function () {
                button.text(button.attr("data-collapsed-text"));
            });

            $(collapseElement).on("show.bs.collapse", function () {
                button.text(button.attr("data-expanded-text"));
            });
        }
    });

    // ------------------------------------------------------- //
    //   Bootstrap tooltips
    // ------------------------------------------------------- //

    $('[data-bs-toggle="tooltip"]').tooltip();

    // ------------------------------------------------------- //
    //   Smooth Scroll
    // ------------------------------------------------------- //

    var smoothScroll = new SmoothScroll("a[data-smooth-scroll]", {
        offset: 80,
    });

    // ------------------------------------------------------- //
    //   Object Fit Images
    // ------------------------------------------------------- //

    objectFitImages();
});
